import React, {Component} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LinearProgress from 'material-ui/LinearProgress';
import RaisedButton from 'material-ui/RaisedButton';
import ReactDOM from 'react-dom';
import {throttle} from 'lodash';
import get from 'lodash.get';
import CheckoutAddress from '../CheckoutAddress';
import {ItemsIcon, BackLeftIcon} from '../../icons';
import {
  HeaderDiv,
  KioskHeaderDiv,
  HeaderTitleDiv,
  KioskHeaderTitleDiv,
  KioskButtonWrapper
} from '../../pages';
import {getSvgIcon, productHasSizes, sliceRewardPoints} from '../../helpers/productHelper';
import CartItem2 from '../CartItem2';
import FieldTestPurchase from '../FieldTestPurchase';
import {getKioskSettings, PAYMENT_STATUS} from '../../actions/pots-api';
import './style.css';
import Warning from './Warning/Warning';
import store from '../../store';
import * as modal from '../../reducers/modalReducer';
import {BODY_TEXT_COLOR, DARK_GREY} from '../../config/colors';
import MsoAchPayment from '../MsoAchPayment';
import { validateLicenseAndViolationBan } from '../../actions/api';
import RedeemRewards from './RedeemRewards.jsx'

const $ = require('jquery');

const styles = {
  editIcon: {width: '30px', height: '30px'},
  button: {width: '100%'},
  kioskCheckoutButton: { width: '90%', marginBottom:'20px' },
  starIcon: {position: 'absolute', width: '30px', height: '30px', margin: '5px 0 0 0', padding: '0 2px 8px', left: '10px'},
  itemsIcon: {position: 'absolute', width: '40px', height: '00px', margin: '5px 0 0 0', padding: '0 2px 8px', left: '10px'},
  deliveryIcon: {position: 'absolute', top: '-5px', width: '30px', height: '30px', margin: '5px 0 0 0', padding: '0 4px 0 0'},
  dispensaryName: {fontWeight: 700},
  total: {fontWeight: 700},
  redeemDollars: {fontWeight: 700, fontSize: '14px'},
  deliveryType: {fontWeight: 700, fontSize: '12px'},
  nums: {fontWeight: 700, fontSize: '15px'},
  asterix: {position: 'absolute', display: 'block', top: '-5px', right: '-15px', color: '#e86a6b', fontSize: '24px'},
  uploadImgContainer: {position: 'relative', width: '30px'},
  totalContainerStyle: {display: "flex", justifyContent: "space-between", padding: "28px 0"},
  disclamerText: { margin: "0 30px", color: DARK_GREY, fontSize: 12 }
};

const idIcon = `${process.env.PUBLIC_URL}/assets/img/icons/id.svg`;
const idIconGreen = `${process.env.PUBLIC_URL}/assets/img/icons/id_green.svg`;
const recIcon = `${process.env.PUBLIC_URL}/assets/img/icons/rec.svg`;
const recIconGreen = `${process.env.PUBLIC_URL}/assets/img/icons/rec_green.svg`;
const DEFAULT_TICKET_TOTAL_VALUE = 0;

export const CheckoutButtonWrapper = styled.div` 
    margin: 20px auto;
    max-width: 550px;
    padding: 0 10px; 
    position: relative;
    text-align: center;
`;

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rewardDollars: 0,
      prevRewardDollars: (0).formatMoney(),
      isDeliveryAddressIncorrect: false,
      isAchPayment: false,
    };
    // this.getSummary = throttle(this.getSummary, 1000, {leading: true, trailing: true});
    this.initSummary = throttle(this.initSummary, 1000, {leading: true, trailing: true});
  }

  secondaryColor = `#${this.props.secondaryColor}`;

  componentDidMount() {
    $(window).scrollTop(0);
    this.initSummary();
    this.checkDeliveryAddress();
  }

  // Checks whether delivery address in an allowed radius
  checkDeliveryAddress = (
    currentAddress = this.props.currentAddress,
    isDelivery = this.props.isDelivery
  ) => {
    if (isDelivery) {
      this.setState({isDeliveryAddressIncorrect: !currentAddress.placeId});
    } else {
      this.setState({isDeliveryAddressIncorrect: false});
    }
  };

  componentWillReceiveProps(nextProps) {
    const nextPayByPoints = this.getPoints(nextProps.summary);
    const payByPoints = this.getPoints(this.props.summary);
    if (payByPoints && payByPoints != nextPayByPoints) {
      setTimeout(() => this.setState({rewardDollars: Math.abs(nextPayByPoints).formatMoney()}), 100);
    }

    if (this.props.currentAddress !== nextProps.currentAddress ||
      // options can be updated when we opening the shipping form
      this.props.deliveryRadius !== nextProps.deliveryRadius) {
      this.checkDeliveryAddress(nextProps.currentAddress, nextProps.isDelivery);
    }
  }

  isSummaryValid(summary) {
    return !!summary;
  }

  getPoints(summary) {
    if (!this.isSummaryValid(summary)) {
      return DEFAULT_TICKET_TOTAL_VALUE;
    }

    return summary.ticketTotals && summary.ticketTotals.payByPoints && Number(summary.ticketTotals.payByPoints);
  }

  getSubTotalBeforeRewardDiscounts() {
    if (!this.isSummaryValid(this.props.summary)) {
      return DEFAULT_TICKET_TOTAL_VALUE;
    }

    const ticketTotals = this.props.summary.ticketTotals;
    if (!ticketTotals) return DEFAULT_TICKET_TOTAL_VALUE

    // adjusted total includes discounts
    // ticketTotals.rewardDiscount total is a negative value
    // so subtracting the rewardsDiscountTotal will be the subtotal with all discounts other than rewards
    return ticketTotals.adjustedSubtotal - ticketTotals.rewardDiscountTotal;
  }

  getSubtotal = () => {
    if (!this.isSummaryValid(this.props.summary)) {
      return DEFAULT_TICKET_TOTAL_VALUE;
    }

    const ticketTotals = this.props.summary.ticketTotals;
    if (!ticketTotals) return DEFAULT_TICKET_TOTAL_VALUE;
    return ticketTotals.adjustedSubtotal + Number(sliceRewardPoints(this.state.prevRewardDollars));
  }

  getFullSubtotal = () => {
    if (!this.isSummaryValid(this.props.summary)) {
      return DEFAULT_TICKET_TOTAL_VALUE;
    }

    const ticketTotals = this.props.summary.ticketTotals;
    if (!ticketTotals) return DEFAULT_TICKET_TOTAL_VALUE;
    return ticketTotals.subTotal + Number(ticketTotals.taxTotal) + Number(ticketTotals.discountTotal) + Number(sliceRewardPoints(this.state.prevRewardDollars));
  }

  initSummary = () => {
    if (this.props.ticketLines.ticketItems.length === 0) {
      this.props.clearSummary();
      return;
    }
    this.props.setFetching(true);
    setTimeout(() => this.props.getSummary({
      ticketItems: this.props.ticketLines.ticketItems,
      isDelivery: this.props.isDelivery
    }, sliceRewardPoints(this.state.rewardDollars)), 0);
  }

  getSummary = () => {
    this.initSummary();
  }

  handleQuantityUp = (item) => {
    if (item.quantity < item.unitsInStock) {
      this.props.increaseProductQnt(item.productId);
    }
  }

  handleQuantityDown = (item) => {
    if (item.quantity === 1) return;
    this.props.substructProductQnt(item.productId);
  }

  handleRemove = (productId) => {
    this.props.removeProduct(productId);
  }

  checkDisabled = () => {
    if (this.props.isKiosk || this.props.isPaymentKiosk) {
      return this.checkDisabledKiosk();
    }

    return this.checkDisabledOnlineMenu();
  };

  checkDisabledOnlineMenu = () => {
    const {
      isDelivery,
      upload,
      isFetching,
      minQty,
      items,
      limitsExceeded,
      totalQuantity
    } = this.props;
    const {isDeliveryAddressIncorrect} = this.state;
    const disabledTechnical = items.length === 0 || !this.getTicketTotals() || upload.inProgress || isFetching;
    const subTotal = this.getSubTotalOrGrandTotal();
    const disabledDeliveryAmount = isDelivery && minQty && parseFloat(subTotal) < parseFloat(minQty);
    const disabledNoDocs = this.checkUser();

    return disabledTechnical || disabledDeliveryAmount || disabledNoDocs || limitsExceeded
          || isDeliveryAddressIncorrect || totalQuantity === 0;
  };

  checkDisabledKiosk = () => {
    const {
      isFetching,
      items,
      limitsExceeded,
      totalQuantity
    } = this.props;
    const disabledTechnical = items.length === 0 || !this.getTicketTotals() || isFetching;

    return disabledTechnical || limitsExceeded || totalQuantity === 0;
  };

  handleKioskCustomerCheckout = () => {
    if (this.checkDisabled()) return;

    const {
      openKioskOrderForm,
      saveTicketFromKioskOrder,
      setFetching,
      resetCheckout
    } = this.props;
    setFetching(true);
    openKioskOrderForm({
      isFromCheckoutPage: true,
      onClose: () => resetCheckout(),
      onSubmit: (formData) => (saveTicketFromKioskOrder(formData))
    });
  };

  handlePlaceOrderClick = async () => {
    const {
      upload,
      saveTicket,
      updateDeliveryOptions,
      checkIsCorrectDeliveryAddress,
      isDelivery,
      isKiosk,
      currentAddress,
      setFetching
    } = this.props;

    const {rewardDollars} = this.state;

    if (upload.checkoutProgress || this.checkDisabled()) {
      return;
    }

    if (isDelivery && !isKiosk) {
      setFetching(true);
      const isCorrectAddress = await updateDeliveryOptions().then(() => checkIsCorrectDeliveryAddress(currentAddress));
      if (!isCorrectAddress) {
        this.setState({ isDeliveryAddressIncorrect: true });
        setFetching(false);
        return;
      }
    }

    saveTicket({rewardDollars, notes: get(this.checkoutAddress, 'state.notes', '')});
  };

  getTotal = () => {
    const ticketTotals = this.getTicketTotals();

    if (!ticketTotals) {
      return DEFAULT_TICKET_TOTAL_VALUE;
    }

    return ticketTotals.total;
  }

  processPaymentAndSaveTicket = async (isKioskCustomer) => {
    if (this.checkDisabled()) {
      return;
    }

    const {
      setFetching,
      openKioskOrderForm,
      hideModal,
    } = this.props;
    setFetching(true);

    let kioskSettings;

    try {
      const getKioskSettingsResult = await getKioskSettings();

      if (typeof getKioskSettingsResult !== 'undefined' && getKioskSettingsResult !== null) {
        kioskSettings = getKioskSettingsResult.data;
      }
    }
    catch(err) {
      kioskSettings = null;
    }
    finally {
      setFetching(false);
    }

    if (typeof kioskSettings === 'undefined' || kioskSettings === null) {
      store.dispatch(modal.openModal({
        modalType: 'GENERIC',
        modalProps: {
          text: 'Payment Kiosk settings are missing',
          stay: true
        }
      }));

      return;
    }

    setFetching(true);

    if (isKioskCustomer) {
      openKioskOrderForm({
        isFromCheckoutPage: true,
        isPaymentKiosk: true,
        onClose: () => {
          setFetching(false);
          hideModal();
        },
        onSubmit: (formData) => {
          hideModal();
          this.waitPaymentStatusAndSaveTicketOrAbort(formData, kioskSettings);
        }
      });
    }
    else {
      this.waitPaymentStatusAndSaveTicketOrAbort({ }, kioskSettings);
    }
  }

  waitPaymentStatusAndSaveTicketOrAbort = async (formData, kioskSettings) => {
    const {
      setFetching,
      addPaymentAndWaitPaymentStatus,
      hideModal,
      saveTicketFromPaymentKioskOrder
    } = this.props;

    const addPaymentResult = await addPaymentAndWaitPaymentStatus(this.getTotal());

    if (addPaymentResult.status === PAYMENT_STATUS.COMPLETED) {
      saveTicketFromPaymentKioskOrder(formData, addPaymentResult.potsTid, kioskSettings);
    } else {
      setFetching(false);
      hideModal();
    }
  }

  isPaymentKiosk = () => false;

  getSubTotalOrGrandTotal = () => {
    const {deliveryMinimumGrandTotal} = this.props;
    return deliveryMinimumGrandTotal ? this.getFullSubtotal() : this.getSubtotal();
  }

  handleAchPayment = () => {
    validateLicenseAndViolationBan(this.props.user.id)
      .then(({data}) => {
        if (data.resultCode === 'FAIL') {
          if (data.resultReason === 'CUSTOMER_WITH_EXPIRED_LICENSE') {
            this.props.openMessageModal({
              message: 'We cannot process ACH payment due to your expired identification. Upload a new ID and complete the transaction by paying in-store.'
            });

          } else if (data.resultReason === 'CUSTOMER_BANNED') {
            this.props.openMessageModal({
              message: 'We cannot process ACH payment due to your banned identification. You can still complete the transaction by paying in-store.'
            });
          }

          return;
        }

        this.setState({
          isAchPayment: true
        });
      })
  }

  handleCheckout = () => {
    this.setState({ isAchPayment: false });
    this.handlePlaceOrderClick();
  };

  promptLoginIfGuest = () => {
    const {
      isUser,
      openLoginForm,
    } = this.props;
    if (!isUser) {
      openLoginForm();
      return false;
    }
    return true;
  }

  handleIdClick = () => {
    if (!this.promptLoginIfGuest()) {
      return;
    }

    if (this.props.upload.inProgress) {
      return null;
    }

    ReactDOM.findDOMNode(this.refs.idFileInput).click();
  }

  handleRecClick = () => {
    if (!this.promptLoginIfGuest()) {
      return;
    }

    if (this.props.upload.inProgress) {
      return null;
    }

    ReactDOM.findDOMNode(this.refs.recFileInput).click();
  }

  handleIdFile = (e) => {
    const {saveDocument, setUser, openUploadSuccess} = this.props;
    const file = $('#id-file')[0].files[0];
    saveDocument(file, 'dl').then((res) => {
      setUser({
        isID: true
      });
      openUploadSuccess();
      $('#id-file')[0].value = null;
    }).catch((err) => {
      $('#id-file')[0].value = null;
    });
  }

  handleRecFile = (e) => {
    const {saveDocument, setUser, openUploadSuccess} = this.props;
    const file = $('#rec-file')[0].files[0];
    saveDocument(file, 'rec').then((res) => {
      setUser({
        isRec: true
      });
      openUploadSuccess();
      $('#rec-file')[0].value = null;
    }).catch((err) => {
      $('#rec-file')[0].value = null;
    });
  }

  getProgressStyle = () => {
    if (this.props.isPaymentKiosk) {
      return {margin: '30px 0'};
    } else { }
  }

  renderProgress = () => {
    if (!this.props.upload.inProgress) return null;
    return <LinearProgress style={this.getProgressStyle()} color="#8BC027" mode="determinate" value={this.props.upload.progress}/>;
  }

  renderCheckoutProgress = () => {
    if (this.props.upload.checkoutProgress || this.props.isFetching) return (<LinearProgress style={this.getProgressStyle()} color="#8BC027" mode="indeterminate"/>);
  }

  renderMinimumQuantity() {
    const {minQty, isDelivery} = this.props;
    if (!minQty || !isDelivery) return null;
    const subTotal = this.getSubTotalOrGrandTotal();
    if (parseFloat(subTotal) >= parseFloat(this.props.minQty)) return null;
    const add = this.props.minQty - subTotal;
    return (
      <div>
        <div className="min-qty-message">
          Your order did not meet minimum order amount for delivery, please add ${add.toFixed(2)} to your cart to meet the ${this.props.minQty} minimum
        </div>
        <hr className={this.getCheckoutSplitterClass()}/>
      </div>
    );
  }

  renderPurchaseLimitsMessage = () => {
    const { limitsExceeded } = this.props;
    if (!limitsExceeded) {
      return null;
    }
    return (
      <div>
        <div className="min-qty-message">
          Adding the item to cart will exceed your purchase limits. Please edit the following cart items to remain within the limit.
        </div>
        <hr className={this.getCheckoutSplitterClass()} />
      </div>
    );
  }

  addRewardDollar = () => {
    let {rewardDollars} = this.state;
    if (rewardDollars[0] === '$') rewardDollars = sliceRewardPoints(rewardDollars);
    const subTotal = this.getSubTotalOrGrandTotal();
    let value;
    if ((Number(rewardDollars) + 10 <= this.props.rewardDollars) && (Number(rewardDollars) + 10 <= subTotal)) {
      value = (Number(rewardDollars) + 10).formatMoney();
    } else if (Number(rewardDollars) + 10 >= subTotal) value = subTotal.formatMoney();
    else value = this.props.rewardDollars.formatMoney();
    this.setState({
      rewardDollars: value,
      prevRewardDollars: value
    }, this.getSummary());
  }

  handleRewardDollars = (e) => {
    let value = Number(e.target.value);
    if (value[0] === '$') value = Number(sliceRewardPoints(value));
    const subTotal = this.getSubtotal();
    const rewardDollars = this.props.rewardDollars;

    if (value < 0) value = 0;
    else if (value <= rewardDollars && value <= subTotal) value = value;
    else if (value >= rewardDollars && value >= subTotal && rewardDollars < subTotal) value = rewardDollars.toFixed(2);
    else if (value >= rewardDollars && value >= subTotal && rewardDollars > subTotal) value = subTotal.toFixed(2);
    else value = rewardDollars.toFixed(2);
    this.setState({
      rewardDollars: value
    });
  }
  rewardDollarsFocus = () => {
    const value = this.state.rewardDollars;
    const newValue = value[0] === '$' ? sliceRewardPoints(value) : 0;
    this.setState({
      rewardDollars: newValue
    });
  }

  rewardDollarsBlur = (e) => {
    let value = e.target.value;
    if (!value || value == 0 || isNaN(value)) value = 0;
    this.setState({
      rewardDollars: value.formatMoney(),
      prevRewardDollars: value.formatMoney()
    }, () => this.getSummary());
  }

  isDiscount(discountTotal) {
    return discountTotal !== 0;
  }

  getTaxValStyle = () => {
    if (this.isExciseTax()) {
      return {position: 'absolute'}
    }
    return {}
  }

  getAsteriks = () => {
    if (!this.isExciseTax()) {
      return null;
    }
    return <span style={this.getTaxValStyle()}>*</span>
  }
  renderSummary = () => {
    let {
      tax,
      summary,
      isFetching,
      isDelivery,
    } = this.props;
    tax = tax.formatMoney();
    // const total = this.props.total.formatMoney();

    const ticketTotals = this.getTicketTotals();
    if (!ticketTotals) return null;
    const filterClass = isFetching ? 'filter' : '';
    const subTotalFinal = ticketTotals.adjustedSubtotal.formatMoney();
    // const taxTotalFinal = ticketTotals.taxTotal.formatMoney();
    const subTotal = ticketTotals.subTotal.formatMoney();
    const taxTotalFinal = ticketTotals && ticketTotals.taxTotal ? ticketTotals.taxTotal.formatMoney() : '$0.00';
    const discountTotalFinal = (ticketTotals.discountTotal).formatMoney();
    const isRewardsDiscount = ticketTotals.rewardDiscountTotal != 0;
    const rewardsDiscountTotal = ticketTotals.rewardDiscountTotal.formatMoney();
    const tierDiscountTotal = ticketTotals.tierDiscountTotal.formatMoney();
    const isDiscount = this.isDiscount(discountTotalFinal);
    const isTierDiscount = this.isDiscount(tierDiscountTotal);
    const deliveryFee = isDelivery && ticketTotals.deliveryFee ? ticketTotals.deliveryFee.formatMoney() : '$0.00';
    const totalFinal = ticketTotals.total.formatMoney();
    return (
      <div style={{position: 'relative'}}>
        <div className={this.getCheckoutItemDetailsClass()}>
          <div><ItemsIcon color="#616161" style={styles.itemsIcon}/></div>
          <div className="treez-checkout-items-details-inner">
            <div className={this.getCheckoutItemDetailsLeftClass()}>
              <div>Original Price:</div>
              {isTierDiscount && <div>Tier Discount: </div>}
              {
                isRewardsDiscount && <div> Rewards Discount: </div>
              }
              {isDiscount && <div>Other Discount: </div>}
              <div>Subtotal:</div>
              <div>Tax:</div>
              {isDelivery && <div>Delivery Fee: </div>}
              {!this.isPaymentKiosk() && <div style={styles.total}>Total:</div>}
            </div>
            <div className={this.getCheckoutItemsDetailsRight()}>
              <span style={this.getPriceStyle()}>{subTotal}</span>
              {isTierDiscount && <span style={this.getPriceStyle()}>{tierDiscountTotal}</span>}
              {
                isRewardsDiscount && <span style={this.getPriceStyle()}>{rewardsDiscountTotal.formatMoney()}</span>
              }
              {isDiscount && <span style={this.getPriceStyle()}>{discountTotalFinal}</span>}
              <span style={this.getPriceStyle()}>{subTotalFinal}</span>
              <span style={this.getPriceStyle()}>{taxTotalFinal}{this.getAsteriks()}</span>
              {isDelivery && this.props.deliveryFee && <span style={this.getPriceStyle()}>{deliveryFee}</span>}
              {!this.isPaymentKiosk() && <span style={styles.total}>{totalFinal}</span>}
            </div>
            {!this.isPaymentKiosk() && <hr className={this.getCheckoutSplitterClass()}/>}
          </div>
        </div>
      </div>
    );
  }

  renderTotal = () => {
    const {summary} = this.props;
    const ticketTotals = summary.ticketTotals;
    if (!ticketTotals) {
      return null;
    }
    const totalFinal = ticketTotals.total.formatMoney();
    return (
      <div>
        <hr className={this.getCheckoutSplitterClass()}/>
        <div style={styles.totalContainerStyle}>
          <div style={{marginLeft: '220px', fontSize: '50px'}}>Total</div>
          <div style={{marginRight: '20px', fontSize: '50px'}}>{totalFinal}</div>
        </div>
      </div>
    );
  }

  checkUser = () => this.props.validateUser();

  renderRec = () => {
    const {
      hasRec
    } = this.props;

    const recLabel = hasRec ? 'REC UPLOADED' : 'UPLOAD DOCS REC';
    const recUploaded = hasRec ? 'green' : 'grey';
    const img = !hasRec ? <img src={recIcon} alt=""/> : <img src={recIconGreen} alt=""/>;
    const asterix = hasRec ? null : (<div style={styles.asterix}>*</div>);

    if (this.props.user.customerType === 'MEDICAL') {
      return (
        <div onClick={this.handleRecClick} className={`treez-checkout-doc ${recUploaded}`}>
          <div style={styles.uploadImgContainer}>
            {asterix}
            {img}
          </div>
          <div className="treez-checkout-doc-text">

            {recLabel}
          </div>
        </div>);
    }
  }

  renderID = () => {
    const {
      hasID
    } = this.props;
    const idUploaded = hasID ? 'green' : 'grey';
    const idLabel = hasID ? 'ID UPLOADED' : 'UPLOAD VALID GOVERNMENT ISSUED ID';
    const img = !hasID ? <img src={idIcon} alt=""/> : <img src={idIconGreen} alt=""/>;
    const asterix = hasID ? null : (<div style={styles.asterix}>*</div>);
    return (
      <div onClick={this.handleIdClick} className={`treez-checkout-doc ${idUploaded}`}>
        <div style={styles.uploadImgContainer}>
          {asterix}
          {img}
        </div>
        <div className="treez-checkout-doc-text">
          {idLabel}
        </div>
      </div>
    );
  }

  isCheckoutButton = () => {
    return true;
  }
  isDocumentButton = () => {
    return true;
  }
  getCheckoutItemsClass = () => {
    const {isFetching} = this.props;
    const filterClass = isFetching ? 'filter' : '';
    if (this.isPaymentKiosk()) {
      return `treez-checkout-items-kiosk ${filterClass}`;
    }

    return `treez-checkout-items ${filterClass}`;
  }

  getCheckoutItemDetailsClass = () => {
    const {isFetching} = this.props;
    const filterClass = isFetching ? 'filter' : '';
    if (this.isPaymentKiosk()) {
      return `treez-checkout-items-details-kiosk ${filterClass}`
    }

    return `treez-checkout-items-details ${filterClass}`
  }

  getCheckoutItemDetailsLeftClass = () => {
    if (this.isPaymentKiosk()) {
      return "treez-checkout-items-details-left-kiosk"
    }

    return  "treez-checkout-items-details-left"
  }
  getCheckoutItemsDetailsRight = () => {
    if (this.isPaymentKiosk()) {
      return "treez-checkout-items-details_right-kiosk";
    }

    return "treez-checkout-items-details_right";
  }
  getCheckoutSplitterClass = () => {
    if (this.isPaymentKiosk()) {
      return "checkout-splitter-kiosk";
    }
    return "checkout-splitter";
  }

  getPriceStyle = () => {
    if (this.isPaymentKiosk()) {
      return {fontWeight: 100, fontSize: '43px'}
    }

    return {fontWeight: 700, fontSize: '15px'}
  }

  getCheckoutClass = () => {
    return this.isPaymentKiosk() ? "treez-checkout-kiosk" : "treez-checkout"
  }
  getEstimatedTaxDisclaimer = () => {
    return (
      <div className="treez-checkout-items">
        <div style={styles.disclamerText}><sup>*</sup>{this.props.estimatedTaxDisclaimer}</div>
      </div>
    )
  }
  isExciseTax = () => {
     if (this.getTicketItems().length === 0) {
       return false;
     }

     const exciseCnt = this.getTicketItems().reduce((acc, t) => {
       return acc + t.ticketItemAreaTaxes.filter(tax => tax.taxType === 'EXCISE').length
     }, 0);
     return exciseCnt > 0 ? true : false;
  }

  getTicketItems() {
    const {
      summary,
    } = this.props;

    return get(summary, 'ticketItems', []);
  }

  getTicketTotals() {
    const {
      summary,
    } = this.props;

    return get(summary, 'ticketTotals', undefined);
  }

  renderMsoAchPayment = () => {
    const {
      items, summary, ticketLines, isMenuOpen,
    } = this.props;

    return (
      <div>
        <div onClick={() => { this.setState({isAchPayment: false}) }} className={'back-btn-wrapper fade-in ' + (!isMenuOpen ? '' : 'hide')}>
          <div className="back-btn-padding step-back"></div>
          <div className="main-category fade-in one"><BackLeftIcon color={BODY_TEXT_COLOR}/></div>
        </div>
        <MsoAchPayment
          items={items}
          summary={summary}
          ticketLines={ticketLines}
          ticketTotals={this.getTicketTotals()}
          ticketItems={this.getTicketItems()}
          rewardDollars={this.state.rewardDollars}
          notes={get(this.checkoutAddress, 'state.notes', '')}
          handleCheckout={this.handleCheckout}
          closeAchPayment={() => this.setState({ isAchPayment: false})}/>
      </div>
    )
  }

  render() {
    const {
      isFetching,
      items,
      secondaryColor,
      isKiosk,
      isMenuOpen,
      isAchPaymentEnabled,
      checkoutPayNowButtonLabel,
      checkoutPayLaterButtonLabel,
      isPhone,
      user,
      allowRewardsRedemptionEcommerce,
    } = this.props;

    if (this.state.isAchPayment) {
      return this.renderMsoAchPayment();
    }

    const btnStyle = this.checkDisabled() ? {color: '#7f7f7f', backgroundColor: '#ccc'} : { };
    const kioskBtnStyle = this.checkDisabled() ?  {color: '#7f7f7f', backgroundColor: '#ccc', height: '120px'} : {height: '120px'};
    // const rewardPoints = this.state.rewardDollars[0] === '$' ? sliceRewardPoints(this.state.rewardDollars) : this.state.rewardDollars;
    // const remainingRewardDollars = (this.props.rewardDollars - rewardPoints).formatMoney();
    return (
      <div className={this.getCheckoutClass()}>
        <div onClick={() => { this.props.goBack() }} className={'back-btn-wrapper fade-in ' + (!isMenuOpen ? '' : 'hide')}>
          <div className="back-btn-padding step-back"></div>
          <div className="main-category fade-in one"><BackLeftIcon color={BODY_TEXT_COLOR}/></div>
        </div>

        {this.isPaymentKiosk() &&
          <KioskHeaderDiv>
            <KioskHeaderTitleDiv>CHECKOUT</KioskHeaderTitleDiv>
          </KioskHeaderDiv>
        }
        {!this.isPaymentKiosk() &&
          <HeaderDiv>
            <HeaderTitleDiv>CHECKOUT</HeaderTitleDiv>
          </HeaderDiv>
        }
        <div className="treez-checkout-items-content">
          <div className={this.getCheckoutItemsClass()}>
            {items.length === 0 && (
              <div className="no-items">No items in your cart yet.</div>
            )
            }
            {items.map((item, index) => <CartItem2
              isWeight={productHasSizes(item.type)}
              color={secondaryColor}
              typeImgSrc={getSvgIcon(item.type)}
              edit
              key={index}
              index={index}
              item={item}
              ticketItems={this.getTicketItems()}
              onQuantityUp={this.handleQuantityUp.bind(null, item)}
              onQuantityDown={this.handleQuantityDown.bind(null, item)}
              onRemove={this.handleRemove.bind(null, item.productId)}
              isPaymentKiosk={this.isPaymentKiosk()}
              isPhone={isPhone}
            />)}
          </div>

          <hr className="checkout-splitter"></hr>

          {this.renderSummary()}

          {this.isPaymentKiosk() &&
            this.renderTotal()
          }

          {!this.isPaymentKiosk() && !isFetching &&
            <hr className={this.getCheckoutSplitterClass()}/>
          }

          {this.isExciseTax() &&
            this.getEstimatedTaxDisclaimer()
          }
          {
            allowRewardsRedemptionEcommerce &&
            items &&
            items.length > 0 &&
            <RedeemRewards
              subTotal={this.getSubTotalBeforeRewardDiscounts()}
              totalRewards={user.rewardPoints / 100}
              rewardsBalance={(user.rewardPoints / 100) - this.state.rewardDollars}
              currentlyRedeeming={this.state.rewardDollars}
              applyRewards={(rewardDollars) => {
                this.props.setFetching(true)
                this.setState({
                  rewardDollars
                });

                setTimeout(() =>
                  this.props.getSummary({
                    ticketItems: this.props.ticketLines.ticketItems,
                    isDelivery: this.props.isDelivery
                  }, sliceRewardPoints(this.state.rewardDollars)).then(() => {
                    this.props.setFetching(false);
                  })
                , 0);

              }}
              secondaryColor={this.secondaryColor}
            />

          }

          <hr className="checkout-splitter"></hr>

          {this.props.isOnlineMenu &&
          <CheckoutAddress
            openShippingForm={this.props.openShippingForm}
            isDelivery={this.props.isDelivery}
            currentAddress={this.props.currentAddress}
            fullName={this.props.fullName}
            notesAllowed={this.props.notesAllowed}
            isDeliveryAddressIncorrect={this.state.isDeliveryAddressIncorrect}
            note={this.props.note}
            getSummary={this.getSummary}
            ref={el => this.checkoutAddress = el}
            secondaryColor={this.secondaryColor}
          />
          }

          {!isFetching && this.props.isOnlineMenu && this.isDocumentButton() &&
            <hr className={this.getCheckoutSplitterClass()}/>
          }

          <div>
            {this.renderProgress()}
            {this.renderCheckoutProgress()}
          </div>

          {this.isDocumentButton() && this.props.isOnlineMenu &&
            <div className="treez-checkout-docs">
              <div style={{display: 'none'}}>
                <input ref="idFileInput" type="file" name="id-file" id="id-file" onChange={this.handleIdFile} accept="image/gif, image/jpeg, image/png"/>
                <input ref="recFileInput" type="file" name="rec-file" id="rec-file" onChange={this.handleRecFile} accept="image/gif, image/jpeg, image/png"/>
              </div>
              {!isKiosk && this.renderID()}
              {!isKiosk && this.renderRec()}
            </div>
          }

          {!isFetching && !this.isPaymentKiosk() && <hr className={this.getCheckoutSplitterClass()}/>}

          {!this.isPaymentKiosk() && this.isCheckoutButton() &&
            <div>
              {this.renderMinimumQuantity()}
              {this.renderPurchaseLimitsMessage()}

              {isAchPaymentEnabled && (
                <CheckoutButtonWrapper>
                  <RaisedButton
                    backgroundColor={this.secondaryColor}
                    labelColor="#FFF"
                    label={checkoutPayNowButtonLabel}
                    labelStyle={{fontWeight: 700}}
                    style={styles.button}
                    buttonStyle={btnStyle}
                    onClick={this.handleAchPayment}
                    disabled={this.checkDisabled()}
                  />
                </CheckoutButtonWrapper>
              )}

              <CheckoutButtonWrapper>
                <RaisedButton
                  backgroundColor={this.secondaryColor}
                  labelColor="#FFF"
                  label={checkoutPayLaterButtonLabel}
                  labelStyle={{fontWeight: 700}}
                  style={styles.button}
                  buttonStyle={btnStyle}
                  onClick={this.handleCheckout}
                  disabled={this.checkDisabled()}
                />
              </CheckoutButtonWrapper>
              <Warning/>
            </div>
          }
        </div>
        {this.isPaymentKiosk() && this.isCheckoutButton() &&
          <div>
            {this.renderPurchaseLimitsMessage()}
            <KioskButtonWrapper>
              <RaisedButton
                backgroundColor={this.secondaryColor}
                labelColor="#FFF"
                label="Checkout"
                labelStyle={{fontWeight: 700, fontSize: '40px'}}
                style={styles.kioskCheckoutButton}
                buttonStyle={kioskBtnStyle}
                onClick={this.handleCheckout}
                disabled={this.checkDisabled()}
              />
            </KioskButtonWrapper>
          </div>
        }
        {this.props.isOrderPlaced &&
          <FieldTestPurchase
            orderId={this.props.orderId}
            totalCost={this.props.totalCost}
          />
        }
      </div>
    );
  }
}

Checkout.defaultProps = {
  note: '',
  fullName: ''
};

Checkout.propTypes = {
  allowRewardsRedemptionEcommerce: PropTypes.bool.isRequired,
  isKioskCustomer: PropTypes.bool.isRequired,
  isKiosk: PropTypes.bool.isRequired,
  notesAllowed: PropTypes.bool.isRequired,
  openKioskOrderForm: PropTypes.func.isRequired,
  saveTicketFromPaymentKioskOrder: PropTypes.func.isRequired,
  saveTicketFromKioskOrder: PropTypes.func.isRequired,
  validateUser: PropTypes.func.isRequired,
  saveTicket: PropTypes.func.isRequired,
  addPaymentAndWaitPaymentStatus: PropTypes.func.isRequired,
  openShippingForm: PropTypes.func.isRequired,
  checkIsCorrectDeliveryAddress: PropTypes.func.isRequired,
  note: PropTypes.string,
  fullName: PropTypes.string,
  isDelivery: PropTypes.bool.isRequired,
  isOrderPlaced: PropTypes.bool.isRequired,
  totalCost: PropTypes.number.isRequired,
  orderId: PropTypes.string.isRequired,
  isPaymentKiosk: PropTypes.bool.isRequired, // mode
  hideModal: PropTypes.func.isRequired
};

export default Checkout;



// WEBPACK FOOTER //
// ./src/components/Checkout/Checkout.jsx